import { defineMessages } from 'react-intl';

const messages: {
	errorStateTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	errorStateSubtitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	errorStateTitle: {
		id: 'rovo-for-you.error-state.title',
		defaultMessage: 'Something went wrong loading this page.',
		description: 'Title text displayed in the error state when a view fails to load',
	},
	errorStateSubtitle: {
		id: 'rovo-for-you.error-state.subtitle',
		defaultMessage: 'Please try again later.',
		description: 'Subtitle text displayed in the error state below the title',
	},
});

export default messages;
